
const SupplyIcon = (props) => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.900146"
      y="1"
      width="49"
      height="49"
      rx="24.5"
      fill="#FDFD1F"
      stroke="#FDFD1F"
    />
    <g clip-path="url(#clip0_1151_9040)">
      <g clip-path="url(#clip1_1151_9040)">
        <path
          d="M31.2496 22.448V22.5772L31.3774 22.5963C34.6887 23.0919 37.2501 26.0691 37.2502 29.6655C37.2502 33.6095 34.1712 36.8078 30.3996 36.8078C29.2896 36.8078 28.2408 36.531 27.3124 36.0403L27.254 36.0094L27.1918 36.0317C25.7739 36.5391 24.1289 36.8078 22.4 36.8078C20.1294 36.8078 17.9866 36.3389 16.3653 35.4945C14.526 34.5365 13.5501 33.2012 13.5501 31.7496V27.5831V23.4168V19.2503C13.5501 17.7988 14.526 16.4634 16.3652 15.5055C17.9865 14.6611 20.1294 14.1921 22.3999 14.1921C24.6702 14.1921 26.813 14.6611 28.4343 15.5055L28.5036 15.3724L28.4343 15.5055C30.2737 16.4634 31.2496 17.7988 31.2496 19.2503V22.448ZM15.4867 26.6295L15.2503 26.4631V26.7522V27.5832C15.2503 28.004 15.4633 28.4187 15.8218 28.7969C16.1812 29.1761 16.6974 29.5303 17.3331 29.834C18.6052 30.4418 20.3777 30.8579 22.4 30.8579C22.7617 30.8579 23.1214 30.8445 23.4765 30.8182L23.635 30.8064L23.6141 30.6488C23.5714 30.3273 23.5489 29.999 23.5489 29.6656C23.5489 29.3071 23.5747 28.9548 23.6238 28.6103L23.6498 28.4273L23.4654 28.4395C23.113 28.4627 22.7575 28.475 22.4 28.475C20.1295 28.475 17.9866 28.006 16.3653 27.1616L16.3653 27.1616C16.0464 26.9955 15.7537 26.8175 15.4867 26.6295ZM24.1416 26.5864L24.2234 26.5764L24.2588 26.502C24.6869 25.6025 25.2912 24.81 26.0246 24.1738L25.8918 23.9146C24.8045 24.1718 23.6206 24.3085 22.4 24.3085C20.1295 24.3085 17.9866 23.8396 16.3653 22.9951L16.3653 22.9951C16.0464 22.8291 15.7537 22.6511 15.4867 22.4631L15.2503 22.2967V22.5857V23.4168C15.2503 23.8376 15.4633 24.2523 15.8218 24.6305C16.1812 25.0096 16.6974 25.3639 17.3331 25.6676C18.6052 26.2753 20.3777 26.6914 22.3999 26.6914C22.9902 26.6914 23.5739 26.656 24.1416 26.5864ZM15.4867 30.7961L15.2503 30.6297V30.9187V31.7497C15.2503 32.1705 15.4633 32.5852 15.8218 32.9634C16.1812 33.3425 16.6974 33.6968 17.3331 34.0005C18.6052 34.6082 20.3777 35.0244 22.3999 35.0244C23.3885 35.0244 24.364 34.9221 25.2659 34.7297L25.5162 34.6763L25.3473 34.484C24.8713 33.942 24.4744 33.3232 24.1755 32.6478L24.1314 32.5483L24.0232 32.5593C23.49 32.6135 22.9469 32.6415 22.4 32.6415C20.1294 32.6415 17.9866 32.1725 16.3653 31.3281L16.296 31.4611L16.3653 31.3281C16.0464 31.162 15.7537 30.9841 15.4867 30.7961ZM30.3803 24.3074L30.3803 24.3074L30.3756 24.3074C27.5408 24.3209 25.249 26.7247 25.249 29.6656C25.249 32.6147 27.5537 35.0244 30.3995 35.0244C33.2453 35.0244 35.55 32.6147 35.55 29.6656C35.55 26.7247 33.2582 24.3209 30.4234 24.3074V24.3073L30.4187 24.3074L30.407 24.308L30.3999 24.3085C30.3998 24.3085 30.3996 24.3085 30.3995 24.3085C30.3993 24.3085 30.3992 24.3085 30.399 24.3085L30.392 24.308L30.3803 24.3074ZM29.5493 19.2503C29.5493 18.8295 29.3364 18.4148 28.9779 18.0366C28.6185 17.6574 28.1023 17.3032 27.4666 16.9995C26.1945 16.3918 24.4221 15.9756 22.3999 15.9756C20.3777 15.9756 18.6052 16.3918 17.3331 16.9995C16.6974 17.3032 16.1812 17.6574 15.8218 18.0366C15.4633 18.4148 15.2503 18.8295 15.2503 19.2503C15.2503 19.6711 15.4633 20.0858 15.8218 20.464C16.1812 20.8432 16.6974 21.1974 17.3331 21.5011C18.6052 22.1089 20.3777 22.525 22.3999 22.525C24.4221 22.525 26.1945 22.1089 27.4666 21.5011C28.1023 21.1974 28.6185 20.8432 28.9779 20.464C29.3364 20.0858 29.5493 19.6711 29.5493 19.2503Z"
          fill="black"
          stroke="black"
          strokeWidth="0.3"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1151_9040">
        <rect
          width="24"
          height="25"
          fill="black"
          transform="translate(13.4001 13)"
        />
      </clipPath>
      <clipPath id="clip1_1151_9040">
        <rect
          width="24"
          height="25"
          fill="black"
          transform="translate(13.4001 13)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SupplyIcon;
